import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { listUsers } from "@/services/adminApi";
import { Users } from "lucide-react";

export function UsersStatCard() {
  const navigate = useNavigate();
  const [total, setTotal] = useState<number | null>(null);
  const [counts, setCounts] = useState<Record<string, number>>({});
  const [businessCount, setBusinessCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await listUsers(navigate);
        setTotal(res.count);
        const grouped: Record<string, number> = {};
        let business = 0;
        for (const u of res.items) {
          const key = u.subscription_type || "none";
          grouped[key] = (grouped[key] || 0) + 1;
          if (u.organization?.is_business) business += 1;
        }
        setCounts(grouped);
        setBusinessCount(business);
      } catch {
        setTotal(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Utilisateurs</CardTitle>
        <Users className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : total !== null ? (
          <>
            <div className="text-2xl font-bold">{total}</div>
            <div className="flex gap-2 mt-1 text-xs text-muted-foreground">
              {Object.entries(counts).map(([k, v]) => (
                <span key={k}>
                  {v} <span className="uppercase">{k}</span>
                </span>
              ))}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              dont <span className="font-medium text-foreground">{businessCount}</span> compte
              {businessCount > 1 ? "s" : ""} business
            </div>
          </>
        ) : (
          <div className="text-sm text-red-600">Erreur</div>
        )}
      </CardContent>
    </Card>
  );
}
